/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks */
import Component from '@ember/component';
import { isArray } from '@ember/array';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import { tracked } from '@glimmer/tracking';

@tagName('')
export default class GroupGoalCard extends Component {
  @service
  features;

  goal = null;
  states = null;
  numLearners = 0;
  isPeakTime = false;
  openGoalDialog() {}

  // The states that @states.secure gives. The caller gives a store.query
  // Promise, which has no length, so the card keeps the resolved array here.
  // It is null until the load of the current @states.secure completes.
  @tracked
  secureStates = null;

  #secureSource;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    let source = this.states?.secure;
    if (source === this.#secureSource) {
      return;
    }
    this.#secureSource = source;
    this.secureStates = null;
    Promise.resolve(source).then((secure) => {
      // Ignore a load that a newer @states replaced.
      if (source === this.#secureSource && !this.isDestroying) {
        this.secureStates = secure ?? [];
      }
    });
  }

  @action
  percentage(amount) {
    let numLearners = this.numLearners;
    if (isArray(amount)) {
      amount = amount.length;
    }
    return numLearners ? (amount / numLearners) * 100 : 0;
  }

  @action
  percentageShort(amount) {
    let numLearners = this.numLearners;
    if (isArray(amount)) {
      amount = amount.length;
    }
    return numLearners ? ((amount / numLearners) * 100).toFixed(2) : '0.00';
  }

  @action
  handleOpenGoalDialog(goal) {
    this.openGoalDialog(goal);
  }
}
